<template>
  <div class="PPTwrap">
    <div class="pptBanner">
      <img :src="banner" alt="">
    </div>
    <div class="PPTtab">
      <ul>
        <li @click="List" v-bind:class="{ active: bar}">PPT列表</li>
        <li @click="Introduce" v-bind:class="{ active: about}">会议介绍</li>
      </ul>
    </div>
    <div v-if="bar" class="PPTlist">
      <ul>
        <li v-for="(item,index) in scrollList" :key="index" @click="pptjump(item.id)">
          <div class="left">
            <img :src="item.middle_picture" alt="">
          </div>
          <div class="right">
            <h3>{{ item.title}}</h3>
           <p class="name">{{ item.subtitle }}</p>
            <p class="hitNum">{{ item.hitNum }}人浏览</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="about" v-if="about">
      <iframe :src="html" frameborder="0" class="htmlContent"></iframe>
    </div>
    <a id="demoHref" :href="downloadUrl" v-show="false"></a>
    <returnPre></returnPre>
  </div>
</template>

<script>
  import api from 'api'
  export default {
    name: 'technicaltopic',
    data() {
      return {
        banner: '',
        PPTurl: '',
        pptId: '',
        html: '',
        about: false,
        bar: true,
        scrollList: [],
        inWx: false,
        downloadUrl: ''
      };
    },
    created() {
      const that = this;
      that.pptId = this.$route.query.aid
      let aid = that.pptId
      this.PPTurl = "api/ppt/getMeetingPpt?mid=" + aid;
      this.$axios.get(that.PPTurl).then(res => {
        that.banner = res.data.data.meetingInfo.middlePicture
        console.log('ppt详情获取的数据 ', res)
        that.html = res.data.data.meetingInfo.about
        this.scrollList = res.data.data.ppts
      });
      this.checkBrow()
    },
    mounted() {
      this.initData()
    },
    methods: {
      // 初始化
      async initData() {
        const params = {
          targetType: 'ppt',
          targetId: this.$route.query.aid
        }
        const res = await api.common.getShareData(params)
        console.log('code====', res)
        if (res.code === 0) {
          this.getShareInfo(true, res.data.shareTitle, res.data.shareDesc, res.data.shareImg)
        } else {
          this.getShareInfo()
        }
      },
      List() {
        this.bar = true;
        this.about = false;
      },
      Introduce() {
        this.bar = false;
        this.about = true;
      },
      pptjump(pptid) {
        if (this.inWx) { // 微信上不方便下载
          alert('请在浏览器上打开此页面查看ppt')
        } else {
          let aid = this.$route.params.tid;
          console.log(aid)
          let ppturl = ''
          this.$axios.get('api/ppt/getmeetingpptdetail/?fileid=' + pptid).then(res => {
            console.log('返回', res)
            ppturl = res.data.data.info.url
            if (ppturl !== null) {
              this.downloadFile(ppturl)
            } else {
              alert('暂无数据')
            }
            // this.downloadFile(ppturl)
            // window.open(ppturl)
            // window.location.href = ppturl
            // alert('安卓手机用户观看ppt需要下载之后更改文件名后缀为.pdf方可观看')
            console.log('ppturl2', ppturl)
          })
        }
      },
      downloadFile(url) {
        document.getElementById('demoHref').href = url
        document.getElementById("demoHref").click();
      },
      // 判断浏览器
      checkBrow() {
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if (isWeixin) {
          this.inWx = true
        } else {
          this.inWx = false
        }
      }
    },
    updated() {
       // document.querySelector('.about p img').style.width = '100%'
    }
  }
</script>

<style scoped lang="less">
  ul{
    margin: 0 !important;
  }
  h3{
    margin-top: 8px;
    font-size: 18px !important;
    line-height: 30px;
  }
  .PPTwrap {
    position: relative;
    overflow-y: hidden;
    .pptBanner {
      width: 100%;
      height: 400px;
      display: flex;
      justify-content: center;

      img {
        position: relative;
        margin: 0;
        width: 100%;
        height: inherit;
        text-align: center;
      }
    }
    .techscroll {
    }
  }

  .PPTtab {
    width: 100%;
    ul {
      /* width: 750px; */
      margin: 0 !important;
      padding: 9px 400px 0 29px;
      background-color: #f4f4f4;
      box-sizing: border-box;
      list-style: none;
      display: flex;
      li {
        margin: 0 !important;
        width: 220px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        flex: 1;
      }
      .active {
        border-bottom: 1px solid #3e92cb; /*no*/
      }
    }
  }

  .about {
    width: 750px;
    padding-top: 10px;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 88px;
    p {
      width: 750px !important;

      box-sizing: border-box;
      img {
        width: 750px !important;
      }
    }
  }

  .PPTlist {
    margin-bottom: 92px;
  }
  .ppTlist ul{
    margin: 0px !important;
  }
  .htmlContent{
    width: 100%;
    min-height: 600px;
  }
  ul{
    padding: 0;
  }
  .PPTlist ul li {
    /* width: 750px; */
    height: 219px;
    box-sizing: border-box;
    border-bottom: 1px solid #b3b3b3; /*no*/
    list-style: none;
    position: relative;
    .left {
      top: 28px;
      width: 270px;
      height: 169px;
      line-height: 169px;
      left: 40px;
      border-radius: 10px;
      overflow: hidden;
      position: absolute;
      > img {
        width: 270px;
        height: 169px;
      }
      p {
        position: absolute;
        line-height: 30px;
        left: 0;
        color: #fff;
        top: 15px;
        font-size: 18px; /*px*/
        padding: 2px 10px;
      }
    }
    .right {
      width: 390px;
      position: absolute;
      left: 320px;
      top: 30px;
      .title {
        font-size: 26px; /*px*/
        // line-height: 56px;
        height: 76px;
        font-weight: 100;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .name {
        color: #f2845a;
        margin-top: 20px;
        margin-bottom: 6px;
      }
      .hitNum {

        color: #8c8c8c;
        span {
          float: right;
        }
      }
      .hitNum {
        margin-top: 5px;
        span {
          color: #fe0200;
          font-weight: 700;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage-Children/PPTdetail.vue